import {
  DefaultContent,
  Kpi,
  PreferenceDetails,
  SavedDataView,
  SortPreference,
} from "../../services/KPIPreferences/savedKpiPreferencesAPI.types";

export const getSavedKpiPreferencesForView = (
  viewName: string,
  savedKpiPreferencesData: PreferenceDetails,
): string[] => {
  return (
    savedKpiPreferencesData.savedDataViews?.[viewName]?.availableKpis
      .filter((kpi: Kpi) => kpi.displaydefault)
      .map((kpi: Kpi) => kpi.id) || []
  );
};

export const updateSavedKpiPreferencesForView = (
  viewName: string,
  viewDisplayName: string,
  availableKpis: string[],
  selectedKpis: string[],
  savedKpiPreferencesData: PreferenceDetails,
  defaultContent: DefaultContent,
  translate: (key: string, defaultValue: string) => string,
): { preferenceDetails: PreferenceDetails; value: SavedDataView } => {
  const kpisToDisplay = availableKpis.map((kpi, index) => ({
    id: kpi,
    displaydefault: selectedKpis.includes(kpi),
    label: translate(kpi, defaultContent[kpi]),
    sequence: index,
  }));
  const value = { viewDisplayName, availableKpis: kpisToDisplay, timestamp: new Date().getTime() };
  return {
    preferenceDetails: {
      ...savedKpiPreferencesData,
      savedDataViews: { ...savedKpiPreferencesData.savedDataViews, [viewName]: value },
    },
    value,
  };
};

export const getSavedSortPreferenceForView = (
  viewName: string,
  savedKpiPreferencesData: PreferenceDetails,
): Pick<SortPreference, "kpi" | "direction"> | undefined => {
  const saved =
    savedKpiPreferencesData.savedDataViews?.[viewName]?.savedSortPreference ??
    savedKpiPreferencesData.savedSortPreferences?.[viewName];
  return saved ? { kpi: saved.kpi, direction: saved.direction } : undefined;
};

export const updateSavedSortPreferenceForView = (
  viewName: string,
  kpi: string,
  direction: SortPreference["direction"],
  savedKpiPreferencesData: PreferenceDetails,
): { preferenceDetails: PreferenceDetails; value: SavedDataView } => {
  const savedSortPreference = { kpi, direction, timestamp: new Date().getTime() };
  const existingView = savedKpiPreferencesData.savedDataViews[viewName];
  const value: SavedDataView = {
    viewDisplayName: existingView?.viewDisplayName ?? viewName,
    availableKpis: existingView?.availableKpis ?? [],
    timestamp: existingView?.timestamp ?? savedSortPreference.timestamp,
    savedSortPreference,
  };
  return {
    preferenceDetails: {
      ...savedKpiPreferencesData,
      savedDataViews: { ...savedKpiPreferencesData.savedDataViews, [viewName]: value },
    },
    value,
  };
};
